<template>
  <div>
    <v-layout>
      <v-flex class="mt-2">
        <h3>メイプルストーリーM 便利サイト</h3>
      </v-flex>
    </v-layout>

    <div class="mt-4">
      <span>これからコンテンツ増やしていく予定</span>
    </div>

    <v-card to="/char" class="mt-3">
      <v-img :src="cardImg" height="150px">
        <v-container fill-height fluid pa-2>
          <v-layout align-end justify-end row class="text-xs-right">
            <v-flex class="mr-3">
              <span class="headline white--text">キャラルーティン管理 </span>
              <v-icon dark>touch_app</v-icon>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
    </v-card>
  </div>
</template>

<script>
export default {
  title: 'ホーム',
  data: () => ({
    cardImg: require('../assets/contents/card01.png'),
  }),
}
</script>
